import cookie from 'react-cookie';

export const storage = {
  getItem : async (item) => {
    // if(localStorage) {
    //   return localStorage.getItem(item)
    // }
    return await Promise.resolve(cookie.load(item))
  },
  setItem : async (item, value) => {
    cookie.save(item, value, {path : '/'});
    await Promise.resolve();
  },
  removeItem : async (item) => {
    // if(localStorage) {
    //   return localStorage.removeItem(item);
    // }
    cookie.remove(item);
    await Promise.resolve();
  }
}



// WEBPACK FOOTER //
// ./src/storage.js